import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';


@Component({
  selector: 'app-straight-bid',
  imports: [FontAwesomeModule,
    ButtonModule,
    DialogModule
  ],
  templateUrl: './straight-bid.component.html',
  styleUrl: './straight-bid.component.scss'
})
export class StraightBidComponent {
  faCheckCircle = faCheckCircle;

  @Input() visible = false;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

}
